import { jsx, jsxs } from "react/jsx-runtime";
import "react";
import { Box, Flex, Text } from "pcln-design-system";
import { RatingDivider } from "./Ratings.styles.js";
const Ratings = ({ guestRating, hotelRating, overallRating })=>/*#__PURE__*/ jsxs(Flex, {
        alignItems: 'center',
        "data-testid": "ratings-wrapper",
        children: [
            /*#__PURE__*/ jsx(Box, {
                bg: 'alert.base',
                borderRadius: 'md',
                textAlign: 'center',
                children: /*#__PURE__*/ jsx(Text, {
                    color: 'text.lightest',
                    fontSize: 0,
                    fontWeight: "bold",
                    lineHeight: '16px',
                    p: '2px',
                    px: '7px',
                    children: overallRating
                })
            }),
            /*#__PURE__*/ jsx(Box, {
                children: /*#__PURE__*/ jsxs(Text, {
                    fontSize: '11px',
                    lineHeight: "15px",
                    ml: 2,
                    color: 'text.base',
                    children: [
                        guestRating,
                        " Ratings"
                    ]
                })
            }),
            Number(hotelRating) > 0 ? /*#__PURE__*/ jsxs(Flex, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ jsx(RatingDivider, {
                        "data-testid": "rating-divider"
                    }),
                    /*#__PURE__*/ jsx(Box, {
                        children: /*#__PURE__*/ jsxs(Text, {
                            fontSize: '11px',
                            lineHeight: "15px",
                            color: 'text.base',
                            children: [
                                hotelRating,
                                "-Star Hotel"
                            ]
                        })
                    })
                ]
            }) : null
        ]
    });
const Ratings_Ratings = Ratings;
export { Ratings_Ratings as default };
